import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propShape, propStr } from '../../../../helpers/custom-prop-types';
import HtmlLink from '../../../Ui/Common/HtmlLink';
import Hover from '../../../Ui/System/Hover';
/**
 * ヘッダーのメニューアイコンを表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchHeaderIcons = (props) => {
    const { className, links: rawLinks } = props;
    const links = useMemo(() => [
        rawLinks.folder,
        rawLinks.accountList,
        rawLinks.addAccount,
        rawLinks.share,
        rawLinks.beginner,
    ], [rawLinks]);
    return (_jsx("ul", Object.assign({ className: clsx('slide_search_header_icons', className) }, { children: links.map((v) => (_jsx(Hover, { children: _jsx("li", Object.assign({ className: clsx('icon_item', v.className) }, { children: _jsxs(HtmlLink, Object.assign({ className: 'item_inner', isNoLinkComponent: v.onClick ? 'button' : undefined, onClickNoLink: v.onClick, target: v.className === 'beginner' ? '_blank' : '_self', to: v.to }, { children: [_jsx("div", Object.assign({ className: 'item_top' }, { children: v.icon })), _jsx("div", Object.assign({ className: 'item_bottom' }, { children: v.text }))] })) })) }, v.text))) })));
};
SlideSearchHeaderIcons.propTypes = {
    className: propStr(),
    links: propShape().isRequired,
};
SlideSearchHeaderIcons.defaultProps = {
    className: '',
};
export default SlideSearchHeaderIcons;
